<script>
import {
  ArrowUpIcon,
  ArrowRightCircleIcon,
  CornerDownRightIcon,
} from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";

/**
 * Changelog-list
 */
export default {
  data() {
    return {
      showTaskModal: false,
      taskForm: {
        name: "",
        phone: "",
        idcard: "",
        company: "",
      },
      taskTitle: "",
      recruitTitles: [
        "抖音主播招募令｜零门槛，秀出你！",
        "地产全民营销经纪人火热招募｜零经验，创高薪！",
      ],
      taskList: [
        {
          title: "抖音主播招募令｜零门槛，秀出你！",
          paragraphs: [
            "不论才艺高低，只要心怀主播梦！我们正在寻找热爱镜头、敢于表达的你。无需经验，不限风格，有一颗热爱行业的心就够了！",
            "要求身心健康，积极向上，遵纪守法，正能量满满。我们将提供专业运营扶持，助你快速成长！",
            "如果你准备好了，欢迎加入我们，一起玩转抖音，开启闪光的主播之路！💫",
            "📩 有意者请点击领取任务报名，联系我们～。",
          ],
          signCompanyId: 34, // 嘉景云数字科技（徐州）有限公司34
          companyId: 1000, // 抖音1000
        },
        {
          title: "地产全民营销经纪人火热招募｜零经验，创高薪！",
          paragraphs: [
            "欢迎加入知名地产营销平台！无论你是否有销售背景，只要对地产行业充满热情，我们都为你敞开大门。无需经验，平台提供专业培训与资源支持，助你快速上手！",
            "要求身心健康、遵纪守法、积极正能量。时间自由，模式灵活，高额佣金等你来拿。",
            "一起抓住地产营销新机遇，实现个人价值与收入双增长！有意者欢迎咨询，携手共创佳绩。",
            "📩 有意者请点击领取任务报名，联系我们～。",
          ],
          signCompanyId: 34, // 嘉景云数字科技（徐州）有限公司34
          companyId: 1001, // 明源云客1001
        },
      ],
    };
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    ArrowUpIcon,
    ArrowRightCircleIcon,
    CornerDownRightIcon,
  },
  methods: {
    getDefaultForm() {
      return {
        name: '',
        phone: '',
        idcard: '',
        company: '',
        companyId: '',
        signCompanyId: ''
      };
    },
    openTaskModal(idx) {
      const task = this.taskList[idx];
      this.taskTitle = task.title;
      this.showTaskModal = true;
      this.taskForm.company = task.companyId === 1000 ? "抖音" : "明源云客";
      this.taskForm.companyId = task.companyId;
      this.taskForm.signCompanyId = task.signCompanyId;
    },
    submitTaskForm(e) {
      e.preventDefault();
      const _data = {
        name: this.taskForm.name,
        mobile: this.taskForm.phone,
        idcard: this.taskForm.idcard,
        company: this.taskForm.company,
        taskTitle: this.taskTitle,
        signCompanyId: this.taskForm.signCompanyId,
        companyId: this.taskForm.companyId,
      };
      if (
        !this.taskForm.name ||
        !this.taskForm.phone ||
        !this.taskForm.idcard ||
        !this.taskForm.company
      ) {
        this.$bvToast.toast("请填写完整信息！", {
          title: "提交",
          toaster: "b-toaster-top-right",
        });
        return;
      }
      this.$axios
        .post("https://centerapi.91qt.com/api/sign_task_list/add", _data)
        .then((res) => {
          if (res.data && res.data.code === 0) {
            this.$bvToast.toast("提交成功，稍后客户经理会与您联系", {
              title: "提示",
              variant: "success",
              solid: true,
            });
            this.showTaskModal = false;
            this.taskForm = this.getDefaultForm();
          } else {
            this.$bvToast.toast(
              res.data && res.data.msg ? res.data.msg : "提交失败",
              {
                title: "错误",
                variant: "danger",
                solid: true,
              }
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- 任务中心 -->
    <section class="bg-half bg-light d-table w-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <h4 class="title">任务中心</h4>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Shape Start -->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!--Shape End-->

    <!-- Changelog Start -->
    <section class="section">
      <div class="container">
        <!-- 招募令内容行1 和 行2 替换为循环渲染 -->
        <div
          v-for="(task, idx) in taskList"
          :key="idx"
          class="row justify-content-center mb-4"
        >
          <div class="col-lg-9">
            <div class="p-4 shadow rounded border">
              <div class="mb-4">
                <h5 class="text-primary">{{ task.title }}</h5>
                <p v-for="(p, pi) in task.paragraphs" :key="pi">{{ p }}</p>
              </div>
              <div class="mt-4">
                <a
                  href="javascript:void(0)"
                  class="btn btn-primary"
                  @click="openTaskModal(idx)"
                  >领取任务</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showTaskModal" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <h3>报名领取任务</h3>
            <form @submit.prevent="submitTaskForm">
              <div class="form-group mb-2">
                <label>姓名</label>
                <input
                  v-model="taskForm.name"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group mb-2">
                <label>手机号</label>
                <input
                  v-model="taskForm.phone"
                  type="tel"
                  maxlength="11"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group mb-2">
                <label>身份证号</label>
                <input
                  v-model="taskForm.idcard"
                  type="text"
                  maxlength="18"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group mb-2">
                <label>客户公司</label>
                <input
                  v-model="taskForm.company"
                  type="text"
                  class="form-control bg-light text-muted"
                  readonly
                />
              </div>
              <div class="mt-3 text-end">
                <button
                  type="button"
                  class="btn btn-secondary me-2 mr-2"
                  @click="showTaskModal = false"
                >
                  取消
                </button>
                <button type="submit" class="btn btn-primary">提交</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.modal-container {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  min-width: 320px;
  max-width: 90vw;
}
</style>
